import { EntityDeleteConfirmationDialogComponent } from './components/entity-delete-confirmation-dialog/entity-delete-confirmation-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { DividerComponent } from './components/divider/divider.component';
import { NgModule } from '@angular/core';
import { MatSnackBarDirective } from './directives/mat-snackbar.directive';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigateBackComponent } from './components/navigate-back/navigate-back.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ConfirmActionComponent } from './components/confirm-action/confirm-action.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FilterByLetterComponent } from './components/filter-by-letter/filter-by-letter.component';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import {
  FiltersComponent,
  PropFilterDialogComponent,
} from './components/collection-filter/filters/filters.component';
import { SearchFilterComponent } from './components/collection-filter/search-filter/search-filter.component';
import { PropFilterComponent } from './components/collection-filter/prop-filter/prop-filter.component';
import { SingleSelectPropFilterComponent } from './components/collection-filter/single-select-prop-filter/single-select-prop-filter.component';
import { MultiSelectPropFilterComponent } from './components/collection-filter/multi-select-prop-filter/multi-select-prop-filter.component';
import { CheckboxPropFilterComponent } from './components/collection-filter/checkbox-prop-filter/checkbox-prop-filter.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TextSearchFilterComponent } from './components/coll-filters/search-filter/text-search-filter.component';
import { PurposesListComponent } from '../manage-account/components/purposes/purposes-list.component';
import { AskConfirmationDialogComponent } from './components/ask-confirmation-dialog/ask-confirmation-dialog.component';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { PageSpinnerComponent } from './components/page-spinner/page-spinner.component';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { UppercaseFirstCharPipe } from './pipes/uppercase-first-char.pipe';
import { PlanningTableComponent } from './components/planning-table/planning-table.component';
import { PlanningTableKpiDialogComponent } from './components/planning-table/edit-kpi-dialog.component';
import { PlanningTableActionDialogComponent } from './components/planning-table/edit-action-dialog.component';
import { AddActionDialogComponent } from './components/planning-table/add-action-dialog.component';
import { AddKpiDialogComponent } from './components/planning-table/add-kpi-dialog.component';
import { MatTableModule} from '@angular/material/table';
import { PurposeComponent } from '../manage-account/components/purpose/purpose.component';
import { DiscardOrSaveComponent } from './components/benefits/discard-or-save/discard-or-save.component';
import { ActionsAndKpiListComponent } from './components/benefits/actions-and-kpi-list/actions-and-kpi-list.component';
import { ImageUploaderComponent} from './components/image-uploader/image-uploader.component';
import { DeleteButtonWithConfirmationComponent } from './components/delete-button-with-confirmation/delete-button-with-confirmation.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { ReadonlyDirective } from './directives/readonly.directive';
import { DisableInputDirective } from './directives/disable-input.directive';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { UserInviteDialogComponent, UsersComponent } from './components/users/users.component';
import { StoreModule } from '@ngrx/store';
import { managementFeatureKey, reducers as managementReducers } from './store/reducers';
import { ListItemBoxComponent } from './components/list-item-box/list-item-box.component';
import { DeleteDialogActionComponent } from '../actions/components/delete-dialog.component';

const maskConfig: Partial<NgxMaskConfig> = {
    validation: true,
};

@NgModule({
    exports: [
        FiltersComponent,
        DividerComponent,
        UppercaseFirstCharPipe,
        MatSnackBarDirective,
        PageHeaderComponent,
        ConfirmActionComponent,
        FilterByLetterComponent,
        TranslateModule,
        TextSearchFilterComponent,
        PageSpinnerComponent,
        PlanningTableComponent,
        PurposesListComponent,
        ImageUploaderComponent,
        DeleteButtonWithConfirmationComponent,
        EntityDeleteConfirmationDialogComponent,
        BarChartComponent,
        ReadonlyDirective,
        DisableInputDirective,
        UsersComponent,
        UserInviteDialogComponent,
        ListItemBoxComponent
    ],
    imports: [
        TranslateModule,
        MatStepperModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatDividerModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        RouterModule,
        CommonModule,
        FormsModule,
        MatIconModule,
        MatSnackBarModule,
        MatButtonModule,
        MatDialogModule,
        MatInputModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatTableModule,
        MatOptionModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgChartsModule,
        MatPaginatorModule,
        StoreModule.forFeature(managementFeatureKey, managementReducers),
        MatSnackBarDirective,
        DividerComponent,
        NavigateBackComponent,
        AddActionDialogComponent,
        AddKpiDialogComponent,
        PageHeaderComponent,
        ConfirmActionComponent,
        FilterByLetterComponent,
        FiltersComponent,
        SearchFilterComponent,
        PropFilterComponent,
        SingleSelectPropFilterComponent,
        MultiSelectPropFilterComponent,
        EntityDeleteConfirmationDialogComponent,
        PropFilterDialogComponent,
        CheckboxPropFilterComponent,
        TextSearchFilterComponent,
        AskConfirmationDialogComponent,
        DeleteDialogActionComponent,
        PageSpinnerComponent,
        UppercaseFirstCharPipe,
        PlanningTableComponent,
        PlanningTableKpiDialogComponent,
        PurposesListComponent,
        PlanningTableActionDialogComponent,
        PurposeComponent,
        DiscardOrSaveComponent,
        ActionsAndKpiListComponent,
        ImageUploaderComponent,
        DeleteButtonWithConfirmationComponent,
        BarChartComponent,
        ReadonlyDirective,
        DisableInputDirective,
        UsersComponent,
        UserInviteDialogComponent,
        ListItemBoxComponent,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        provideEnvironmentNgxMask(maskConfig),
    ],
})
export class SharedModule {}
